import { Outlet } from "react-router-dom";
import NavBar from "./NavBar";
import ShowNavBar from "../utils/ShowNavBar";

const DefaultComponent = () => {

  return (
    <div className="flex flex-col h-screen overflow-hidden bg-gradient-to-b from-[#0a0f1e] to-[#070c18]">
      <ShowNavBar>
        <NavBar />
      </ShowNavBar>
      <div className="flex-1 w-full max-w-full relative overflow-y-auto overflow-x-hidden min-h-0 custom-scrollbar flex flex-col">
        <Outlet />
      </div>
    </div>
  );
};

export default DefaultComponent;
